import React, { useState } from "react";
import { FeedItem, Icon } from "@culturehq/components";

import { useDoor } from "app/hooks";

import ErrorBoundary from "components/common/ErrorBoundary";
import { RecognitionCheers } from "components/common/Cheers";
import { RecognitionComments } from "components/Comments";

import RecognitionQuickLinks from "./recognition/RecognitionQuickLinks";
import RecognitionHeader from "./recognition/RecognitionHeader";
import RecognitionMiddle from "./recognition/RecognitionMiddle";

const Recognition = ({
  recognition: propsRecognition,
  stickyQuickLinks,
  userActivity,
  header,
  onApprove,
  onUserActivityUpdate
}) => {
  const { open: deleted, onOpen: toggleDeleted } = useDoor(false);
  const { open: showComments, onToggle: toggleShowComments } = useDoor(true);
  const [commentCount, setCommentCount] = useState(propsRecognition.commentCount);

  if (deleted) {
    return null;
  }

  const recognition = { ...propsRecognition, commentCount };

  return (
    <FeedItem className="recognitions__recognition">
      {header}
      <FeedItem.Body>
        <ErrorBoundary>
          <RecognitionQuickLinks
            sticky={stickyQuickLinks}
            recognition={recognition}
            userActivity={userActivity}
            onDelete={toggleDeleted}
            onApprove={onApprove}
            onUserActivityUpdate={onUserActivityUpdate}
          />
          <RecognitionHeader recognition={recognition} />
          <RecognitionMiddle recognition={recognition} />
        </ErrorBoundary>
      </FeedItem.Body>
      <FeedItem.Footer>
        <RecognitionCheers recognition={recognition} />
        <div
          className="btn FeedItem__footer__comment-button clickable"
          onClick={toggleShowComments}
        >
          <Icon icon="ios-chatbubble-outline" />{" "}
          <span>Comment{recognition.commentCount > 0 && `s (${recognition.commentCount})`}</span>
        </div>
        {showComments && (
          <RecognitionComments recognition={recognition} onChange={setCommentCount} />
        )}
      </FeedItem.Footer>
    </FeedItem>
  );
};

export default Recognition;
